/**
 * Token-Kit Developer Portal — Environment Configuration
 *
 * All values are sourced from REACT_APP_* environment variables,
 * which are baked in at build time by Create React App.
 *
 * For local development, create a .env.local file with these values.
 * For Amplify, set them in the Amplify Console > Environment Variables.
 *
 * SECURITY: Never hardcode Cognito pool IDs, client IDs, or API URLs
 * as fallback defaults here. They must come from env vars or .env.local.
 */

export const appConfig = {
  /** Base URL for the Token-Kit API (e.g. https://api-dev.token-kit.com) */
  apiUrl: process.env.REACT_APP_API_URL || '',

  /** Cognito User Pool ID (e.g. us-east-1_XXXXXXX) */
  cognitoUserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',

  /** Cognito App Client ID */
  cognitoClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',

  /** AWS region for Cognito */
  cognitoRegion: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',

  /** API version prefix */
  apiVersion: 'v1',
} as const;
